import React from 'react';
import { Box, Grid, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import CountDownTimer from '../shared/CountDownTimer';
import { logoutUrl } from '../shared/Links';
import { dispatchOverlayLoad } from '../shared/Analytics';
import workerScript from './interval.worker';
import axiosInstance from '../../actions/AxiosInstance';
import ErrorIcon from '../../assets/images/icons/Error_Icon.svg';
import api from '../../actions/EndPoints';
import { log, setLastRequestTime, resetMgpTimer, closeModal, showModal } from '../../Utils';
import { PsBeaconButton, PsBeaconModal } from '../shared/BeaconRegister';

const SessionTimerModal = ({ state }) => {
    const [modalIsOpen, setModalOpen] = React.useState(false);
    const apiKey = state ? state.apiKey : null;
    const [logOutLoader, setLogoutLoader] = React.useState(false);
    const [disableKOBtn, setDisablekeepMeOnline] = React.useState(false);
    const [keepSession, setKeepSession] = React.useState(false);
    const [countdownActive, setCountdownActive] = React.useState(false);
    const countDownTime = 120000;
    const events = ['click'];

    const SESSION_TIMEOUT_MINUTES = 28;

    const openSessionModal = () => {
        showModal('session-timer-modal');
        dispatchOverlayLoad('Session Timed Out');
        setModalOpen(true);
        setCountdownActive(true);
    };

    const closeSessionModal = () => {
        closeModal('session-timer-modal');
        setModalOpen(false);
        setCountdownActive(false);
    };

    const continueSession = () => {
        closeSessionModal();
        setKeepSession(true);
        setLastRequestTime();
        log(console.log('User selected to Stay Online'));
    };

    const logOutFPS = () => {
        closeSessionModal();
        showModal('session-logout-loader-modal');
        dispatchOverlayLoad('Session Logout Loading');
        window.location.href = logoutUrl;
        const keysToRemove = ['emailInv', 'invitePinNumber', 'lastRequestTime', 'joiningRasHH'];
        keysToRemove.forEach((k) => localStorage.removeItem(k));
        keysToRemove.forEach((k) => sessionStorage.removeItem(k));
    };

    // To set and reset session timer
    React.useEffect(() => {
        let resetTokenExpiration = false;
        let autoTime;
        let modalOpen;
        let lastRequestTimeMilliseconds =
            JSON.parse(localStorage.getItem('lastRequestTime')) || null;
        let timeInSecondsSinceLastRequest = Math.ceil(
            (Date.now() - lastRequestTimeMilliseconds) / 1000
        );
        let timeInSecondsUntilExpire = SESSION_TIMEOUT_MINUTES * 60 - timeInSecondsSinceLastRequest;

        const logOutFPSTabs = () => {
            setLogoutLoader(true);
            closeSessionModal();
            showModal('session-logout-loader-modal');
            dispatchOverlayLoad('Session Logout Loading');
            window.location.href = logoutUrl;
            localStorage.removeItem('lastRequestTime');
        };

        const resetAutoTimer = () => {
            clearTimeout(autoTime);
            setLastRequestTime();
            modalOpen = false;
            log(console.log('Auto Timer Reset'));
        };
        const resetAutoTimerTabs = () => {
            clearTimeout(autoTime);
            modalOpen = false;
            log(console.log('Auto Timer Reset'));
        };
        const resetLastRequestTime = async () => {
            lastRequestTimeMilliseconds =
                JSON.parse(localStorage.getItem('lastRequestTime')) || null;
            timeInSecondsSinceLastRequest = Math.ceil(
                (Date.now() - lastRequestTimeMilliseconds) / 1000
            );
            timeInSecondsUntilExpire = SESSION_TIMEOUT_MINUTES * 60 - timeInSecondsSinceLastRequest;

            if (modalOpen && timeInSecondsUntilExpire > 0 && !keepSession) {
                log(console.log('timer reset in other tab'));
                resetAutoTimerTabs();
                modalOpen = false;
                closeSessionModal();
            }
            // user logged out in other tab
            if (modalOpen && !lastRequestTimeMilliseconds) {
                log(console.log('user logged out in other tab'));
                logOutFPSTabs();
                modalOpen = false;
            }
            if (timeInSecondsUntilExpire === 0 && !modalIsOpen) {
                openSessionModal();
                setKeepSession(false);
                modalOpen = true;
                autoTime = setTimeout(() => {
                    setLogoutLoader(true);
                    setDisablekeepMeOnline(true);
                    window.location.href = logoutUrl;
                    setTimeout(() => {
                        closeSessionModal();
                    }, 5000);
                    log(console.log('Your Timer Is Out , You are logged out'));
                }, countDownTime);
                const el = document.getElementById('keep-session');
                Object.keys(events).forEach((key) => {
                    el.addEventListener(events[key], resetAutoTimer);
                });
            }
            // If modal is open in multiple tabs and keep me online is selected
            if (modalIsOpen && timeInSecondsUntilExpire > 0) {
                log(console.log('timer reset in other tab'));
                closeSessionModal();
                modalOpen = false;
            }
            if (modalIsOpen && timeInSecondsUntilExpire === -120) {
                log(console.log('timeInSecondsUntilExpire time out', timeInSecondsUntilExpire));
                closeSessionModal();
            }
        };
        if (
            !resetTokenExpiration &&
            lastRequestTimeMilliseconds &&
            timeInSecondsUntilExpire < 1800 &&
            timeInSecondsUntilExpire > 0
        ) {
            setInterval(() => resetLastRequestTime(), 1000);
        }
        return () => {
            resetTokenExpiration = true;
        };
    }, [events, keepSession, modalIsOpen]);

    // Keep the token alive so that user is still authenticated
    // User can only logout using logout btn on overlay or shared-nav and timeout
    React.useEffect(() => {
        let resetTokenExpiration = false;
        const testWorker = new Worker(workerScript);
        const establishSessionAffinity = async () => {
            try {
                const sessionAffiinityData = await axiosInstance.get(api.sessionAffinity, {
                    headers: { apiKey },
                });
                if (sessionAffiinityData) {
                    log(console.log('success'));
                }
            } catch (error) {
                log(console.log(error));
            }
        };

        if (!resetTokenExpiration) {
            testWorker.postMessage('start');
            testWorker.onmessage = function (event) {
                if (event.data === 'timerCompleted') {
                    establishSessionAffinity();
                    resetMgpTimer();
                }
            };
        }

        return () => {
            testWorker.terminate();
            resetTokenExpiration = true;
        };
    }, [apiKey]);

    return (
        <PsBeaconModal id="session-timer-modal">
            <Box
                id="session-timer-container"
                className="beacon-on-light beacon-theme-modern-outlook">
                <Box id="session-timer-content-container">
                    <Box sx={{ paddingBottom: '12px' }} id="error-img-container">
                        <img src={ErrorIcon} alt="loading-error" id={`session-timer-error-img}`} />
                    </Box>
                    <Typography
                        type="headline" serif scale={300} bold
                        id="session-timer-title"
                        sx={{ paddingBottom: '16px' }}>
                        You are about to be logged out
                    </Typography>
                    <Typography
                        type="body" scale={100}
                        id="session-timer-notice"
                        sx={{ paddingBottom: '16px' }}>
                        We have noticed that you have been inactive for a while. For your security,
                        we&apos;ll automatically log you out in approximately{' '}
                        <span id="session-timer-counter" className="b-font-weight-bold">
                            <CountDownTimer
                                countdownActive={countdownActive}
                                countDownTime={!logOutLoader ? countDownTime / 1000 : 0}
                            />
                            .
                        </span>
                    </Typography>
                    <Typography
                        id="button-disclosure"
                        type="body" scale={100} bold
                        sx={{ paddingBottom: '32px' }}>
                        Click &quot;Keep Me Online&quot; to continue using your online accounts. If
                        you&apos;re done, you may click &quot;Log Out&quot;.
                    </Typography>
                </Box>
            </Box>
            <Box id="session-timer-button-container" style={{ width: '100%' }}>
                <Grid container id="session-timer-button-grid-container">
                    <Grid item cols={12} lg={6}>
                        <PsBeaconButton
                            disabled={logOutLoader}
                            id="logout"
                            variant="secondary"
                            onClick={logOutFPS}
                            style={{ width: '100%' }}>
                            Log Out
                        </PsBeaconButton>
                    </Grid>
                    <Grid item cols={12} lg={6}>
                        <PsBeaconButton
                            disabled={disableKOBtn}
                            id="keep-session"
                            onClick={continueSession}
                            style={{ width: '100%' }}>
                            Keep Me Online
                        </PsBeaconButton>
                    </Grid>
                </Grid>
            </Box>
        </PsBeaconModal>
    );
};

export default function SessionTimer({ state }) {
    return <SessionTimerModal state={state} />;
}
